import { dateformat } from '../../helpers';
import {
  ACTIVO_PRECIOS_CUSTOM,
  GET_DATA_SEARCH_AREAS_PRECIOS_CUSTOM,
  GET_DATE_SEARCH_PRECIOS_CUSTOM,
  GETALL_PRECIOS_CUSTOM,
  LOADING_GETALL_PRECIOS_CUSTOM,
  SET_LOGOUT,
} from '../../store/Types';

const initialState = {
  all: [],
  meta: null,
  links: null,
  activo: null,
  params: [],
  dateSearchOrigin: dateformat(null, {}),
  dateSearch: dateformat(null, { format: 'DD-MM-YYYY' }),
  dataSearchAreaId: null,
  loadingGetAll: false,
};

export const preciosCustomReducer = (state = initialState, action) => {
  switch (action.type) {
    case GETALL_PRECIOS_CUSTOM:
      return {
        ...state,
        all: action.payload,
      };
    case ACTIVO_PRECIOS_CUSTOM:
      return {
        ...state,
        activo: action.payload,
      };
    case SET_LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    case LOADING_GETALL_PRECIOS_CUSTOM:
      return {
        ...state,
        loadingGetAll: action.payload,
      };
    case GET_DATE_SEARCH_PRECIOS_CUSTOM:
      return {
        ...state,
        dateSearchOrigin: action.payload,
        dateSearch: dateformat(action.payload, {
          format: 'YYYY-MM-DD HH:mm:ss',
        }),
      };
    case GET_DATA_SEARCH_AREAS_PRECIOS_CUSTOM:
      return {
        ...state,
        dataSearchAreaId: action.payload,
      };

    default:
      return state;
  }
};
